<template>
  <card>
    <list
      v-if="$store.state.user.sections['promotions']"
      :columns="columns"
      :modalCreate="modalCreate"
      :removeLink="removeLink"
      :cardLink="cardLink"
      :isUpdate="true"
      :isAdd="true"
      :itemLink="itemLink"
      :setLink="setLink"
      :openItem="true"
      :fields="fields"
      :params="params"
      :searchDisable="true"
      @change="change"
      @changeFunction="changeFunction"
      v-model="val"
    />
  </card>
</template>
<script>
export default {
  name: "products",
  methods: {
    changeFunction(val) {},
    change(val) {},
  },
  data() {
    return {
      params: {},
      val: [],
      modalCreate: "season",
      fields: [
        {
          col: " col-12 col-md-6",
          key: "name",
          label: "Название",
          type: "field",
          textType: "text",
        },
      ],
      /** APIs */
      removeLink: "",
      cardLink: "item_promotion",
      itemLink: "promotions",
      setLink: "promotions",
      columns: [
        {
          key: "name",
          title: "Название",
        },
        {
          key: "is_active",
          title: "Активность",
        },
        {
          key: "shops",
          title: "Торговые точки",
          titleKey: "shops",
          object: "name",
          disableLink: true,
        },
        {
          detail: true,
          // remove: true,
        },
      ],
    };
  },
};
</script>
<style>
</style>
